import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import App from "./App.js";

import "./App.css";

<App />;

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
